// virusData.js - Données statiques des virus pour fallback

export const VIRUS_DATA = {
  grippe: {
    id: 'grippe',
    name: 'Grippe saisonnière',
    icon: '🤒',
    color: '#3B82F6', // Bleu
    colorLight: '#DBEAFE',
    colorDark: '#1E40AF',
    description:
      'Infection respiratoire virale très contagieuse, survenant principalement en hiver.',
    symptoms: [
      'Fièvre élevée (39-40°C)',
      'Courbatures et douleurs musculaires',
      'Maux de tête intenses',
      'Fatigue extrême',
      'Toux sèche',
      'Frissons',
      'Mal de gorge',
    ],
    transmission: [
      'Gouttelettes respiratoires (toux, éternuements)',
      'Contact avec des surfaces contaminées',
      'Contact direct avec une personne infectée',
    ],
    prevention: [
      'Vaccination annuelle (recommandée)',
      'Lavage fréquent des mains',
      'Port du masque en période épidémique',
      'Aération régulière des pièces',
      'Éviter les contacts rapprochés avec les malades',
    ],
    duration: '5 à 7 jours',
    incubation: '1 à 3 jours',
    riskGroups: [
      'Personnes âgées (65+)',
      'Femmes enceintes',
      'Nourrissons',
      'Personnes immunodéprimées',
    ],
    whenToConsult: [
      'Difficultés respiratoires',
      'Fièvre persistante > 3 jours',
      'Confusion ou désorientation',
      'Douleur thoracique',
    ],
  },
  covid: {
    id: 'covid',
    name: 'Covid-19',
    icon: '🦠',
    color: '#8B5CF6', // Violet
    colorLight: '#EDE9FE',
    colorDark: '#5B21B6',
    description: 'Maladie infectieuse causée par le coronavirus SARS-CoV-2.',
    symptoms: [
      'Fièvre ou frissons',
      'Toux',
      'Fatigue',
      "Perte du goût ou de l'odorat",
      'Essoufflement',
      'Maux de tête',
      'Douleurs musculaires',
      'Mal de gorge',
      'Congestion nasale',
    ],
    transmission: [
      'Gouttelettes et aérosols respiratoires',
      'Contact rapproché prolongé',
      'Espaces clos mal ventilés',
    ],
    prevention: [
      'Vaccination à jour',
      'Port du masque en intérieur',
      'Lavage des mains régulier',
      'Aération des espaces clos',
      'Distanciation physique',
    ],
    duration: '7 à 14 jours (variable)',
    incubation: '2 à 14 jours (moyenne 5 jours)',
    riskGroups: ['Personnes âgées', 'Personnes avec comorbidités', 'Personnes immunodéprimées'],
    whenToConsult: [
      'Difficultés respiratoires sévères',
      'Douleur thoracique persistante',
      'Confusion',
      'Lèvres ou visage bleutés',
    ],
  },
  gastro: {
    id: 'gastro',
    name: 'Gastro-entérite',
    icon: '🤢',
    color: '#10B981', // Vert
    colorLight: '#D1FAE5',
    colorDark: '#047857',
    description:
      "Infection du système digestif causant inflammation de l'estomac et des intestins.",
    symptoms: [
      'Diarrhée aiguë',
      'Nausées et vomissements',
      'Crampes abdominales',
      'Fièvre légère',
      'Fatigue',
      "Perte d'appétit",
      'Déshydratation',
    ],
    transmission: [
      'Contact avec une personne infectée',
      'Aliments ou eau contaminés',
      'Surfaces contaminées (poignées, toilettes)',
      'Transmission féco-orale',
    ],
    prevention: [
      'Lavage des mains très fréquent',
      'Désinfection des surfaces',
      'Bien cuire les aliments',
      "Éviter le partage d'objets personnels",
      'Isolement des personnes malades',
    ],
    duration: '1 à 3 jours',
    incubation: '24 à 72 heures',
    riskGroups: ['Nourrissons', 'Jeunes enfants', 'Personnes âgées'],
    whenToConsult: [
      'Signes de déshydratation',
      'Sang dans les selles',
      'Fièvre > 39°C',
      'Vomissements persistants > 24h',
      'Nourrisson ou personne âgée',
    ],
  },
  bronchiolite: {
    id: 'bronchiolite',
    name: 'Bronchiolite',
    icon: '👶',
    color: '#F59E0B', // Orange
    colorLight: '#FEF3C7',
    colorDark: '#B45309',
    description:
      'Infection respiratoire virale touchant principalement les nourrissons et jeunes enfants.',
    symptoms: [
      'Toux',
      'Respiration rapide et sifflante',
      'Difficultés à respirer',
      'Nez qui coule',
      'Fièvre modérée',
      "Difficultés à s'alimenter",
      'Fatigue inhabituelle',
    ],
    transmission: [
      'Gouttelettes respiratoires',
      'Contact direct (mains, bisous)',
      'Objets contaminés (jouets, tétines)',
    ],
    prevention: [
      'Lavage des mains avant de toucher bébé',
      'Éviter les contacts avec personnes enrhumées',
      'Aérer régulièrement',
      'Ne pas partager biberons/tétines',
      'Reporter les visites si symptômes',
    ],
    duration: '7 à 10 jours',
    incubation: '2 à 8 jours',
    riskGroups: [
      'Nourrissons < 2 ans',
      'Prématurés',
      'Bébés avec problèmes cardiaques ou pulmonaires',
    ],
    whenToConsult: [
      'Respiration très rapide ou difficile',
      'Pauses respiratoires',
      "Refus de s'alimenter",
      'Teint pâle ou bleuté',
      'Bébé < 3 mois avec fièvre',
    ],
  },
};

// Données des régions françaises avec coordonnées pour la carte
export const REGIONS_DATA = {
  'ile-de-france': { name: 'Île-de-France', code: '11' },
  'centre-val-de-loire': { name: 'Centre-Val de Loire', code: '24' },
  'bourgogne-franche-comte': { name: 'Bourgogne-Franche-Comté', code: '27' },
  normandie: { name: 'Normandie', code: '28' },
  'hauts-de-france': { name: 'Hauts-de-France', code: '32' },
  'grand-est': { name: 'Grand Est', code: '44' },
  'pays-de-la-loire': { name: 'Pays de la Loire', code: '52' },
  bretagne: { name: 'Bretagne', code: '53' },
  'nouvelle-aquitaine': { name: 'Nouvelle-Aquitaine', code: '75' },
  occitanie: { name: 'Occitanie', code: '76' },
  'auvergne-rhone-alpes': { name: 'Auvergne-Rhône-Alpes', code: '84' },
  'provence-alpes-cote-d-azur': { name: "Provence-Alpes-Côte d'Azur", code: '93' },
  corse: { name: 'Corse', code: '94' },
};

// Niveaux d'alerte
export const ALERT_LEVELS = {
  low: {
    level: 'low',
    label: 'Faible',
    color: '#10B981',
    bgColor: '#D1FAE5',
    textColor: '#065F46',
    description: 'Circulation faible du virus',
  },
  moderate: {
    level: 'moderate',
    label: 'Modéré',
    color: '#F59E0B',
    bgColor: '#FEF3C7',
    textColor: '#92400E',
    description: 'Circulation modérée, vigilance recommandée',
  },
  high: {
    level: 'high',
    label: 'Élevé',
    color: '#EF4444',
    bgColor: '#FEE2E2',
    textColor: '#991B1B',
    description: 'Circulation active, précautions nécessaires',
  },
  epidemic: {
    level: 'epidemic',
    label: 'Épidémie',
    color: '#7C3AED',
    bgColor: '#EDE9FE',
    textColor: '#5B21B6',
    description: 'Seuil épidémique franchi',
  },
};

// Données statiques de fallback (simulées)
export const FALLBACK_EPIDEMIC_DATA = {
  lastUpdate: new Date().toISOString(),
  source: 'Données de démonstration',
  national: {
    grippe: { level: 'moderate', trend: 'up', percentage: 12 },
    covid: { level: 'low', trend: 'stable', percentage: 0 },
    gastro: { level: 'high', trend: 'up', percentage: 25 },
    bronchiolite: { level: 'moderate', trend: 'down', percentage: -8 },
  },
  regions: {
    'ile-de-france': {
      grippe: 'high',
      covid: 'moderate',
      gastro: 'high',
      bronchiolite: 'moderate',
    },
    'hauts-de-france': {
      grippe: 'high',
      covid: 'low',
      gastro: 'epidemic',
      bronchiolite: 'high',
    },
    'grand-est': {
      grippe: 'moderate',
      covid: 'low',
      gastro: 'high',
      bronchiolite: 'moderate',
    },
    normandie: {
      grippe: 'moderate',
      covid: 'low',
      gastro: 'moderate',
      bronchiolite: 'low',
    },
    bretagne: {
      grippe: 'low',
      covid: 'low',
      gastro: 'moderate',
      bronchiolite: 'low',
    },
    'pays-de-la-loire': {
      grippe: 'moderate',
      covid: 'low',
      gastro: 'moderate',
      bronchiolite: 'moderate',
    },
    'centre-val-de-loire': {
      grippe: 'moderate',
      covid: 'low',
      gastro: 'high',
      bronchiolite: 'low',
    },
    'bourgogne-franche-comte': {
      grippe: 'low',
      covid: 'low',
      gastro: 'moderate',
      bronchiolite: 'low',
    },
    'nouvelle-aquitaine': {
      grippe: 'low',
      covid: 'low',
      gastro: 'low',
      bronchiolite: 'low',
    },
    occitanie: {
      grippe: 'moderate',
      covid: 'low',
      gastro: 'moderate',
      bronchiolite: 'moderate',
    },
    'auvergne-rhone-alpes': {
      grippe: 'high',
      covid: 'moderate',
      gastro: 'high',
      bronchiolite: 'high',
    },
    'provence-alpes-cote-d-azur': {
      grippe: 'moderate',
      covid: 'low',
      gastro: 'moderate',
      bronchiolite: 'low',
    },
    corse: {
      grippe: 'low',
      covid: 'low',
      gastro: 'low',
      bronchiolite: 'low',
    },
  },
};
